import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeGrandTotalInCurrencyCommand extends BaseCommand {
  CommandName = "ChangeGrandTotalInCurrency";
  Command: {
    Amount: number;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, amount: number) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Amount: amount };
  }
}
